import { useQuery } from '@apollo/client';

import { GetAllCitiesByStateDocument } from 'src/gql/graphql';
import type { State } from 'src/gql/graphql';
import { GraphqlError } from 'src/errors';
import { removeUnsupportedCities } from './utils';

type UseCitiesPageReturn = {
  citiesByState: State[];
  loading: boolean;
};

export const useCitiesPage = (): UseCitiesPageReturn => {
  const { data, loading, error } = useQuery(GetAllCitiesByStateDocument);

  if (error) {
    throw new GraphqlError(error);
  }

  // Remove cities for which a city page cannot be created
  removeUnsupportedCities(data);

  const citiesByState = data?.statesWithDispensaries ?? [];

  return {
    citiesByState,
    loading,
  };
};
